





import { Component, Vue } from "vue-property-decorator"
import downloadApp from '@ivy/fts/inner/topBarOpenApp.vue'
@Component({
  components: {
    downloadApp
  },
})
export default class DownloadApp extends Vue {
}
